/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action
} from "vuex-module-decorators";
import store from "@/admin/store";

@Module({
  name: "globals",
  store: store,
  namespaced: true,
  dynamic: true
})
class GlobalModule extends VuexModule {
  isSpScreenWidth = true;
  isLargeBreakpointWidthOfSp = true;
  scrollDirection = false;
  scrollYPosition = 0;
  screenWidth = document.body.clientWidth;
  windowHeight = document.body.clientHeight;
  terminalType = false;
  userAgent = false;
  browser = "";
  name = "";

  @Mutation
  setIsSpScreenWidth(value: boolean) {
    this.isSpScreenWidth = value;
  }
  @Mutation
  setIsLargeBreakpointWidthOfSp(value: boolean) {
    this.isLargeBreakpointWidthOfSp = value;
  }
  @Mutation
  setScrollDirection(value: boolean) {
    this.scrollDirection = value;
  }
  @Mutation
  setScrollYPosition(value: number) {
    this.scrollYPosition = value;
  }
  @Mutation
  setScreenWidth(value: any) {
    this.screenWidth = value;
  }
  @Mutation
  setWindowHeight(value: any) {
    this.windowHeight = value;
  }
  @Mutation
  setTerminalType(value: any) {
    this.terminalType = value;
  }
  @Mutation
  setUserAgent(value: any) {
    this.userAgent = value;
  }
  @Mutation
  setBrowser(value: any) {
    this.browser = value;
  }

  @Action
  getisSpScreenWidth() {
    const timer = 0;
    const reSize = () => {
      if (timer > 0) {
        clearTimeout(timer);
      }
      setTimeout(() => {
        if (window.innerWidth < 769) {
          this.context.commit("setIsSpScreenWidth", true);
        } else {
          this.context.commit("setIsSpScreenWidth", false);
        }

        if (window.innerWidth < 1111) {
          this.context.commit("setIsLargeBreakpointWidthOfSp", true);
        } else {
          this.context.commit("setIsLargeBreakpointWidthOfSp", false);
        }

        this.context.commit("setWindowHeight", document.body.clientHeight);
        this.context.commit("setScreenWidth", window.innerWidth);
      }, 200);
    };
    reSize();
    window.addEventListener("resize", reSize);
  }

  @Action({ rawError: true })
  getScrollDirection() {
    let scrollPosition = 0;
    let directionState: any;

    const scrollFunction = () => {
      requestAnimationFrame(() => {
        const { scrollY } = window;

        if (scrollY === scrollPosition) {
          // eslint-disable-next-line no-self-assign
          directionState = directionState;
        } else if (scrollY > scrollPosition) {
          directionState = "down";
        } else {
          directionState = "up";
        }

        this.context.commit("setScrollDirection", directionState);
        this.context.commit("setScrollYPosition", scrollY);
        scrollPosition = scrollY;
      });
    };

    window.addEventListener("scroll", scrollFunction);
  }

  @Action({ rawError: true })
  getUserAgent() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const tablet = /iphone|ipad|android/;
    let terminalType;
    if (tablet.test(userAgent)) {
      terminalType = "sp";
    } else {
      terminalType = "pc";
    }

    let browser;

    if (userAgent.includes("msie") || userAgent.includes("trident")) {
      browser = "ie";
    } else if (userAgent.includes("edge")) {
      browser = "edge";
    } else if (userAgent.includes("chrome")) {
      browser = "chrome";
    } else if (userAgent.includes("safari")) {
      browser = "safari";
    } else if (userAgent.includes("firefox")) {
      browser = "fireFox";
    } else if (userAgent.includes("opera")) {
      browser = "opera";
    } else {
      browser = "undefined";
    }

    this.context.commit("setTerminalType", terminalType);
    this.context.commit("setUserAgent", userAgent);
    this.context.commit("setBrowser", browser);
  }
}
export default getModule(GlobalModule);
